export default {
  /**
   * 将金额从分转换为元
   *
   * @method fen2Yuan
   * @param {String} val 需要进行转换的数额
   * @return {String} 转换后的金额
   * @example 123212 -> 1232.12; 123200 -> 1232.00
   */
  fen2Yuan(val) {
    // let result;
    // eslint-disable-next-line no-useless-escape
    const re = /^[\+|-]?[0-9]+$/;
    if (typeof val !== 'string') {
      // eslint-disable-next-line no-param-reassign
      val = val.toString();
    }
    return re.test(val) ? (parseFloat(val) / 100).toFixed(2) : '0.00';
  },
  /**
   * 将金额从分转换为元，如果小数点后两位是0，则去掉小数点
   *
   * @method fen2YuanNoFix
   * @param {String} val 需要进行转换的数额
   * @return {String} 转换后的金额
   * @example 123212 -> 1232.12; 123200 -> 1232
   */
  fen2YuanNoFix(val) {
    // eslint-disable-next-line no-useless-escape
    const re = /^[\+|-]?[0-9]+$/;
    if (typeof val !== 'string') {
      // eslint-disable-next-line no-param-reassign
      val = val.toString();
    }
    const result = re.test(val) ? (parseFloat(val) / 100).toFixed(2) : '0.00';
    const reArr = result.split('.');
    if ('00' === reArr[1]) {
      return reArr[0];
    }
    return result;
  },
  /**
   * 将金额从元转换为分
   *
   * @method yuan2Fen
   * @param {String} val 需要进行转换的数额
   * @return {String} 转换后的金额
   * @example 123212 -> 12321200
   */
  yuan2Fen(val) {
    // let result;
    // eslint-disable-next-line no-useless-escape
    const re = /^[\+|-]?\d+(\.\d+)?$/;
    if (typeof val !== 'string') {
      // eslint-disable-next-line no-param-reassign
      val = val.toString();
    }
    return re.test(val) ? (parseFloat(val) * 100).toFixed(0) : '0';
  },
  formatMoney(number, places, symbol, thousand, decimal) {
    // eslint-disable-next-line
    number = Number(number) / 100 || 0;
    // eslint-disable-next-line
    places = !isNaN((places = Math.abs(places))) ? places : 2;
    // eslint-disable-next-line
    symbol = symbol !== undefined ? symbol : '￥';
    // eslint-disable-next-line
    thousand = thousand || ',';
    // eslint-disable-next-line
    decimal = decimal || '.';
    const negative = number < 0 ? '-' : '';
    // eslint-disable-next-line
    const i = `${parseInt((number = Math.abs(+number || 0).toFixed(places)), 10)}`;
    // eslint-disable-next-line
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      // eslint-disable-next-line
      // symbol
      // eslint-disable-next-line
      negative
      // eslint-disable-next-line
      + (j ? i.substr(0, j) + thousand : '')
      // eslint-disable-next-line
      + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousand}`)
      // eslint-disable-next-line
      + (places ? decimal + Math.abs(number - i)
        .toFixed(places)
        .slice(2)
        : '')
    );
  },
  /**
   * 将金额进行格式化输出
   *
   * @method toCurrency
   * @requires string
   * @param {String} val 需要进行格式化的数额
   * @param {Number} bit 进行格式化的位数
   * @return {String} 格式化后字符串
   * @example 123212.88 -> 123,212.88
   */
  toCurrency(val, bit, options) {
    // eslint-disable-next-line no-param-reassign
    options = options || { decimal: true };

    // eslint-disable-next-line no-param-reassign
    val = val || '';
    // eslint-disable-next-line no-param-reassign
    bit = bit || 2;

    // eslint-disable-next-line no-useless-escape
    let pattern = /^(\-?)(\d+)(\.\d+)?$/;
    const macher = pattern.exec(val);
    const sign = null !== macher ? RegExp.$1 || '' : '';
    const integer = null !== macher ? RegExp.$2 || '0' : '0';
    let decimal = null !== macher ? RegExp.$3 || '.00' : '.00';
    const size = integer.length;
    const mod = size > 3 ? size % 3 : 0;
    let tmp = '';
    const start = 0 === mod ? '' : `${integer.substr(0, mod)},`;
    let flag = 0;

    if (options.decimal) {
      decimal = '' === decimal ? '.00' : decimal;
      decimal = this.fillAfter(decimal, 0, bit + 1).substr(0, bit + 1);
    } else {
      decimal = '';
    }

    for (let i = mod; i < size; i++) {
      tmp += integer.charAt(i);
      flag += 1;
      if (flag % 3 === 0 && i < size - 1) {
        tmp += ',';
        flag = 0;
      }
    }

    pattern = null;
    return sign + start + tmp + decimal;
  },
  /**
   * 向后填充
   * @method fillAfter
   * @param {String} instr 输入的字符串
   * @param {String} chr 填充的字符
   * @param {Number} bit 位数
   * @return {String} 填充后的字符串
   * @example fillAfter("123", "0", 5) -> 12300
   */
  fillAfter(instr, chr, bit) {
    const len = instr.length;
    const shift = bit - len + 1;
    let str = instr;
    if (shift > 0) {
      let a = new Array(shift);
      str = str + a.join(chr);
      a = null;
    }
    return str;
  },

  /**
   * 校验是否金额数字
   * @method isAmount
   * @param {String} val 输入的字符串
   * @return {Boolean} true | false
   * @example
   * isAmount('0.12') -> true
   * isAmount('000') -> false
   * isAmount('0') -> true
   * isAmount('0.') -> false
   * isAmount('0.0') -> true
   * isAmount('050') -> false
   * isAmount('00050.12') -> false
   * isAmount('70.1') -> true
   * isAmount('70.11') -> true
   * isAmount('70.111')-> false
   * isAmount('500') -> true
   */
  isAmount(val) {
    let newVal = val;
    if (typeof val !== 'string') {
      newVal = val.toString();
    }
    const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    return reg.test(newVal);
  },
};
